import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters.js'

// 这种方式很好的将modules中的所有文件全部导出，这样以后修改modules不用再在此处进行添加导出
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  modules,
})
